import { MenuRoot, MenuContent, MenuTrigger } from 'shared';
import { Icon, iconNames } from 'shared_DEPRECATED/components/Icon';

import {
  GoalBreakdownMenuAddButton,
  GoalBreakdownMenuAddChallengeButton,
} from 'features/goal';

import { ButtonIcon, VARIANTS } from 'shared/components/Button';

export const GoalBreakdownHeaderMenu = () => (
  <MenuRoot>
    <MenuTrigger asChild>
      <ButtonIcon
        aria-label="goal breakdown header menu"
        size="sm"
        color={VARIANTS.PRIMARY}
      >
        <Icon
          name={iconNames.plus}
          stroke="var(--fgPrimaryInverse)"
          strokeWidth={2}
        />
      </ButtonIcon>
    </MenuTrigger>
    <MenuContent py="1px" overflow="hidden">
      <GoalBreakdownMenuAddButton />
      <GoalBreakdownMenuAddChallengeButton />
    </MenuContent>
  </MenuRoot>
);
